import axios from "../../utils/axios";

//用户查询列表
export function listUsers(keyword, orgId, roleName, start, limit) {
  return axios.get(
    `/rs/user?keyword=${keyword}&orgId=${orgId}&roleName=${roleName}&start=${start}&limit=${limit}`
  );
}

//用户新增
export function addUser(user) {
  return axios.put("/rs/user", user);
}

//用户修改
export function updateUser(user) {
  return axios.patch("/rs/user", user);
}

//用户删除或者禁用时校验
export function userDeleteOrDisableVerifyApi(usernames) {
  return axios.get(`/rs/user/delOrDisable/verify/${usernames}`);
}

//用户修改状态
export function userChangeStatusApi(usernames, statusCode) {
  return axios.post(`/rs/user/${usernames}/status/${statusCode}`);
}

//用户删除状态
export function userDeleteApi(usernames) {
  return axios.delete(`/rs/user/${usernames}`);
}

//用户重置密码状态
export function userResetPasswordApi(usernames) {
  return axios.post(`/rs/user/resetPassword/${usernames}`);
}

//判断用户是否被引用
export function ifUserRefApi(username) {
  return axios.get(`/rs/user/${username}/isRef`);
}

export function logoutApi() {
  return axios.get("j_spring_security_logout");
}

//获取短信验证码
export function getPhCode(data) {
  return axios.post("/rs/generalfunction/phonecode", data);
}

export function getTopBarInfoApi() {
  return axios.get("rs/resources/topbar/info");
}

export function getCarouselImg() {
  return axios.get("rs/logo/picture");
}
